module.exports = __webpack_public_path__ + "img/pbx.196a1e92.png";